import React, { useRef, useState } from "react";
import Slider from "react-slick";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { Container, Row, Col } from "react-bootstrap";
import AnimateOnScroll from "../AnimateOnScroll/AnimateOnScroll";
import ImageLoader from "../ImageLoader/ImageLoader";
import { useTranslation } from "react-i18next";

const Clubhouse = () => {
  const { t } = useTranslation();
  const sliderRef = useRef(null);
  const sliderRef2 = useRef(null);

  const [lightbox, setLightbox] = useState({
    open: false,
    slides: [],
    index: 0,
  });

  const openLightbox = (slides, index) => {
    setLightbox({
      open: true,
      slides,
      index,
    });
  };

  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    centerMode: true,
    centerPadding: "0px",
    arrows: false, // We are using custom arrows
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };



  const slider1Content = [
    <div className="image-card" key={2}>
      <img src="/images/new_24.jpg" alt="" />
    </div>,
    <div className="image-card" key={2}>
      <img src="/images/C3. Gym.jpg" alt="" />
    </div>,
    <div className="image-card" key={2}>
      <img src="/images/DDK_0082.jpg" alt="" />
    </div>,
    <div className="image-card" key={2}>
      <img src="/images/club_01.jpg" alt="" />
    </div>,
    <div className="image-card" key={2}>
      <img src="/images/DDK_9133.jpg" alt="" />
    </div>,
    <div className="image-card" key={2}>
      <img src="/images/C3. Club Oasis Indoor pool.jpg" alt="" />
    </div>,
    <div className="image-card" key={2}>
      <img src="/images/club_03.jpg" alt="" />
    </div>,
    <div className="image-card" key={2}>
      <img src="/images/new_30.jpg" alt="" />
    </div>,
    <div className="image-card" key={2}>
      <img src="/images/new_41.jpg" alt="" />
    </div>,
    <div className="image-card" key={2}>
      <img src="/images/club_02.jpg" alt="" />
    </div>,
    <div className="image-card" key={2}>
      <img src="/images/new_25.jpg" alt="" />
    </div>,
    <div className="image-card" key={2}>
      <img src="/images/new_43.jpg" alt="" />
    </div>,
    <div className="image-card" key={2}>
      <img src="/images/new_40.jpg" alt="" />
    </div>,
    <div className="image-card" key={2}>
      <img src="/images/new_37.jpg" alt="" />
    </div>,
    <div className="image-card" key={2}>
      <img src="/images/C3. Gym.jpg" alt="" />
    </div>,
    <div className="image-card" key={2}>
      <img src="/images/DDK_0082.jpg" alt="" />
    </div>,
    <div className="image-card" key={2}>
      <img src="/images/club_01.jpg" alt="" />
    </div>,
    <div className="image-card" key={2}>
      <img src="/images/DDK_9133.jpg" alt="" />
    </div>,
    <div className="image-card" key={2}>
      <img src="/images/C3. Club Oasis Indoor pool.jpg" alt="" />
    </div>,
    <div className="image-card" key={2}>
      <img src="/images/club_03.jpg" alt="" />
    </div>,
    <div className="image-card" key={2}>
      <img src="/images/new_30.jpg" alt="" />
    </div>,
    <div className="image-card" key={2}>
      <img src="/images/new_24.jpg" alt="" />
    </div>,
    <div className="image-card" key={2}>
      <img src="/images/new_41.jpg" alt="" />
    </div>,
    <div className="image-card" key={2}>
      <img src="/images/club_02.jpg" alt="" />
    </div>,
    <div className="image-card" key={2}>
      <img src="/images/new_25.jpg" alt="" />
    </div>,
    <div className="image-card" key={2}>
      <img src="/images/new_43.jpg" alt="" />
    </div>,
    <div className="image-card" key={2}>
      <img src="/images/new_40.jpg" alt="" />
    </div>,
    <div className="image-card" key={2}>
      <img src="/images/new_37.jpg" alt="" />
    </div>,
    <div className="image-card" key={2}>
      <img src="/images/C3. Gym.jpg" alt="" />
    </div>,
    <div className="image-card" key={2}>
      <img src="/images/clubhouse.jpg" alt="" />
    </div>,
  ];


  const slides1 = slider1Content.map((card) => ({
    src: card.props.children.props.src,
  }));

  return (
    <ImageLoader>
      <Container>
        <Row>
          <Col>
            <div className="accommodation section">
              <Row>
                <AnimateOnScroll animationType="slideUp">
                  <h2>{t("clubhouse_main_title")}</h2>
                </AnimateOnScroll>
                <AnimateOnScroll animationType="slideUp" delay={0.1}>
                  <p>{t("clubhouse_main_p")}</p>
                </AnimateOnScroll>
              </Row>
              <Row>
                <Col md={12}>
                  <AnimateOnScroll animationType="slideup">
                    <div className="image-slider">
                      <div className="slider-container">
                        <button
                          className="slick-prev-custom"
                          onClick={() => sliderRef.current.slickPrev()}
                        >
                          <FaArrowLeft />
                        </button>
                        <div className="slider-wrapper">
                          <Slider ref={sliderRef} {...sliderSettings}>
                            {slider1Content.map((card, idx) =>
                              React.cloneElement(card, {
                                onClick: () => openLightbox(slides1, idx),
                              }),
                            )}
                          </Slider>
                        </div>
                        <button
                          className="slick-next-custom"
                          onClick={() => sliderRef.current.slickNext()}
                        >
                          <FaArrowRight />
                        </button>
                      </div>
                    </div>
                  </AnimateOnScroll>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
        <Lightbox
          open={lightbox.open}
          close={() => setLightbox({ ...lightbox, open: false })}
          slides={lightbox.slides}
          index={lightbox.index}
        />
        <div className="section">
          <Row>
            <Col md={12}>
              <AnimateOnScroll animationType="slideUp">
                <h2>{t("clubhouse_fit_title")}</h2>
              </AnimateOnScroll>
              <AnimateOnScroll animationType="slideUp" delay={0.1}>
                <p>{t("clubhouse_fit_p")}</p>
              </AnimateOnScroll>
            </Col>
          </Row>
          <Row className="bottom-padding">
            <Col md={12}>
            <video autoPlay muted loop style={{ width: "100%" }}>
                <source
                  src="/images/videos/Oasis pool.mp4"
                  type="video/mp4"
                />
              </video>
            </Col>
            </Row>
          <Row className="bottom-padding">
            <Col md={6}>
              <AnimateOnScroll animationType="slideLeft">
                <img src="/images/E6.jpg" className="fullimg" alt="" />
              </AnimateOnScroll>
            </Col>
            <Col md={6}>
              <AnimateOnScroll animationType="slideRight">
                <img src="/images/E4.jpg" className="fullimg" alt="" />
              </AnimateOnScroll>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <AnimateOnScroll animationType="slideUp">
                <img src="/images/E7.jpg" className="fullimg" alt="" />
              </AnimateOnScroll>
            </Col>
          </Row>
        </div>
        <div className="section">
          <Row>
            <Col md={12}>
              <AnimateOnScroll animationType="slideUp">
                <h2>{t("clubhouse_fun_title")}</h2>
              </AnimateOnScroll>
              <AnimateOnScroll animationType="slideUp" delay={0.1}>
                <p>{t("clubhouse_fun_p")}</p>
              </AnimateOnScroll>
            </Col>
          </Row>

          <Row className="bottom-padding">
            <Col md={12}>
              <video autoPlay muted loop style={{ width: "100%" }}>
                <source
                  src="/images/videos/Children Play.mp4"
                  type="video/mp4"
                />
              </video>
            </Col>
          </Row>
          <Row className="bottom-padding">
            <Col md={6}>
              <AnimateOnScroll animationType="slideLeft">
                <img src="/images/E12.jpg" className="fullimg" alt="" />
              </AnimateOnScroll>
            </Col>
            <Col md={6}>
              <AnimateOnScroll animationType="slideRight">
                <img src="/images/E1.jpg" className="fullimg" alt="" />
              </AnimateOnScroll>
            </Col>
          </Row>
        </div>
        <div className="section">
          <Row>
            <Col md={12}>
              <AnimateOnScroll animationType="slideUp">
                <h2>{t("clubhouse_relax_title")}</h2>
              </AnimateOnScroll>
              <AnimateOnScroll animationType="slideUp" delay={0.1}>
                <p>{t("clubhouse_relax_p")}</p>
              </AnimateOnScroll>
            </Col>
          </Row>

          <Row className="bottom-padding">
            <Col md={12}>
              <video autoPlay muted loop style={{ width: "100%" }}>
                <source src="/images/videos/Oasis spa.mp4" type="video/mp4" />
              </video>
            </Col>
          </Row>
          <Row className="bottom-padding">
            <Col md={6}>
              <AnimateOnScroll animationType="slideLeft">
                <img src="/images/E9.jpg" className="fullimg" alt="" />
              </AnimateOnScroll>
            </Col>
            <Col md={6}>
              <AnimateOnScroll animationType="slideRight">
                <img src="/images/E10.jpg" className="fullimg" alt="" />
              </AnimateOnScroll>
            </Col>
          </Row>
          <Row className="bottom-padding">
            <Col md={12}>
              <video autoPlay muted loop style={{ width: "100%" }}>
                <source
                  src="/images/videos/Chill Area Video.mp4"
                  type="video/mp4"
                />
              </video>
            </Col>
          </Row>
        </div>
      </Container>
    </ImageLoader>
  );
};

export default Clubhouse;
